export default __webpack_public_path__ + "assets/order-management.df3f268f.svg";